import { Box } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { RedoIcon, UndoIcon } from '~/assets/workspace-icons';
import ToolbarButton from '~/components/toolbar/shared/ToolbarButton';
import { useUndoRedo } from '~/hooks/undo/useUndoRedo';
import {
    selectedROIState,
    selectedRoiIsPointTypeState,
} from '~/state/atoms/structureSet/roiAtoms';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';

export default function UndoRedoTool() {
    const selectedRoiNumber = useRecoilValue(selectedROIState);
    const selectedStructureSet = useRecoilValue(currentStructureSetState);
    const isPointRoi = useRecoilValue(selectedRoiIsPointTypeState);
    const { canUndo, canRedo, undo, redo } = useUndoRedo(selectedRoiNumber);

    const isDisabled =
        !selectedStructureSet ||
        selectedStructureSet.roiArray.length === 0 ||
        isPointRoi;

    const selectedRoi = selectedStructureSet?.roiArray.find(
        (roi) => roi.roiNumber === selectedRoiNumber
    );
    const isApproved =
        selectedRoi?.isApproved || selectedStructureSet?.isApproved;

    const getUndoTooltip = (): string => {
        if (isApproved) {
            return 'Structure is approved';
        }
        return canUndo ? 'Undo last change' : 'Nothing to undo';
    };

    const getRedoTooltip = (): string => {
        if (isApproved) {
            return 'Structure is approved';
        }
        return canRedo ? 'Redo last change' : 'Nothing to redo';
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.25,
            }}
        >
            <ToolbarButton
                icon={<UndoIcon />}
                tooltip={getUndoTooltip()}
                disabled={!canUndo || isDisabled || !!isApproved}
                onClick={undo}
            />
            <ToolbarButton
                icon={<RedoIcon />}
                tooltip={getRedoTooltip()}
                disabled={!canRedo || isDisabled || !!isApproved}
                onClick={redo}
            />
        </Box>
    );
}
